import React from "react";
import { useDispatch } from "react-redux";
import { Button, Col, Row, FormGroup, Label, Spinner } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { actions as actionsSite } from "../../redux/actions/site";
import BaseService from "../../services/baseService";
import Error from "../../components/messagesModal/error";
import Success from "../../components/messagesModal/success";

const ModalReprove = ({ row }) => {
  const dispatch = useDispatch();
  const baseService = new BaseService("ondemand-log-query");

  const validation = Yup.object().shape({
    reasonForApproveWithoutResult: Yup.string().required("Motivo é obrigatório"),
  });

  const close = async (data) => {
    const res = await baseService.put(row._id, {status: "Finalizado", reasonForApproveWithoutResult: data.reasonForApproveWithoutResult});

    if (res.error) {
      const configModal = {
        title: 'Erro',
        component: <Error msg={res.msg}/>
      };

      dispatch(actionsSite.setModal(configModal));
      return;
    }

    const configModal = {
      title: 'Sucesso',
      component: <Success msg={'Consulta finalizada com sucesso'} />,
    };

    dispatch(actionsSite.setModal(configModal));
  }

  return (
    <Formik initialValues={{reasonForApproveWithoutResult: ''}}
      validationSchema={validation}
      onSubmit={async (values) => close(values)}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form>
          <Row>
            <Col sm="12">
              <FormGroup>
                <Label>Motivo</Label>
                <Field name="reasonForApproveWithoutResult" placeholder="Motivo da da finalização sem arquivos" className={"form-control" + (errors.reasonForApproveWithoutResult && touched.reasonForApproveWithoutResult ? " is-invalid" : "")}/>
                <ErrorMessage name="reasonForApproveWithoutResult" component="div" className="invalid-feedback" />
              </FormGroup>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <Button type="submit" color="success" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Spinner color="light" size="sm" className="mr-1"/>
                  Processando...
                </>
              ) : (
                <>
                  <i className="fas fa-check mr-2"/>
                  Finalizar consulta
                </>
              )}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ModalReprove;
